/**
 * Resolve the user's first name for display in greetings.
 * Backend auto-sets `name` to the email prefix when the user skips the
 * optional name field at signup — never display that ugly fallback to
 * the user. This helper detects that case and returns a friendly default.
 */
export function resolveFirstName(user, fallback = "friend") {
  const raw = user?.name?.split(" ")?.[0];
  if (!raw) return fallback;
  const emailPrefix = (user?.email || "").split("@")[0];
  // Looks like an email prefix → fall back. Heuristics:
  //   • Exact match with the local-part of the email
  //   • Contains @ or digits (real first names rarely do)
  //   • Contains a hyphen (e.g. "stab-test-1778329864")
  if (raw === emailPrefix || /[@\d]/.test(raw) || raw.includes("-")) {
    return fallback;
  }
  return raw;
}
